import * as styles from "./SliderControl.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Slider as BaseSlider } from "@base-ui/react/slider";

import type { SliderControlProps } from "./Slider.types";

export function SliderControl({
  className,
  ...props
}: SliderControlProps): JSX.Element {
  return (
    <BaseSlider.Control
      data-slot="slider-control"
      className={clsx(styles.control, className)}
      {...props}
    />
  );
}
